import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { Variable } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VariableEndpoints extends ApiBase {
  public getAllVariables(): Observable<Variable[]> {
    return this.get<Variable[]>(`/game/${this.gameId}/data/${this.dataPackage}/variables`);
  }

  public getVariable(variableRef: string): Observable<Variable> {
    return this.get<Variable>(`/game/${this.gameId}/data/${this.dataPackage}/variables/${variableRef}`);
  }

  public createVariable(variable: Variable): Observable<Variable> {
    return this.post<Variable>(`/game/${this.gameId}/data/${this.dataPackage}/variables`, variable);
  }

  public updateVariable(variableRef: string, variable: Variable): Observable<Variable> {
    return this.put<Variable>(`/game/${this.gameId}/data/${this.dataPackage}/variables/${variableRef}`, variable);
  }

  public deleteVariable(variableRef: string): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/data/${this.dataPackage}/variables/${variableRef}`);
  }
}
